import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-enable.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const EnableIcon = createSvgIcon(<Icon />, 'EnableIcon');
